export class Fourchette {

	public valeurBasse: number;

	public valeurHaute: number;

	constructor() { 
		 		this.valeurBasse = 0;
		this.valeurHaute = 0;
 
	}
}
